if (process.env.NODE_ENV === "test") {
  import("@repo/mocks/browser")
    .then(async mod => {
      const worker = mod.createWorker();
      worker.start({ onUnhandledRequest: "warn" });
    })
    .catch(async () => {
      console.error("Failed to load the browser module");
    });
}
